// extracted by mini-css-extract-plugin
export var page404Title = "howItWorks-module--page404-title--LixXI";
export var videoPanel = "howItWorks-module--videoPanel--mUYz3";
export var videoWrapper = "howItWorks-module--videoWrapper--yi3Rc";